import {Component, Input} from '@angular/core';
import {Contact} from "../../../model/contact";
import {FaqCategory} from "../../../model/FaqCategory";
import {FaqCategoryService} from "../../../services/faq-category.service";
import {UserRequest} from "../../../model/UserRequest";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {CommonModule} from "@angular/common";
import {BadgeComponent} from "../badge/badge.component";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {CopyDirective} from "../../../directives/copy.directive";

@Component({
    selector: 'app-user-request-comparator',
    templateUrl: './user-request-comparator.component.html',
    imports: [
        CommonModule,
        FaIconComponent,
        BadgeComponent,
        NgbTooltip,
        CopyDirective
    ],
    styleUrl: './user-request-comparator.component.scss'
})
export class UserRequestComparatorComponent {
  @Input() user: Contact;
  @Input() request: UserRequest;
  @Input() asAdmin = false;

  constructor(private faq: FaqCategoryService) {
  }

  getFaqCategoryByName(s: string): FaqCategory {
    return this.faq.getFromString(s);
  }

  public static countProductsDiffs(from: UserRequest): number {
    if (from.products) {
      return Object.keys(from.products).length;
    }
    return 0;
  }

  countProductsDiffs(): number {
    return UserRequestComparatorComponent.countProductsDiffs(this.request);
  }

  public static isProfileDifferent(request: UserRequest, user: Contact): boolean {
    return request.profile && request.profile.profile != undefined &&
      ((request.profile.profile === 'Referent' && !user.referent) ||
        (request.profile.profile === 'Simple' && user.referent)) ;
  }

  isProfileDifferent(): boolean {
    return UserRequestComparatorComponent.isProfileDifferent(this.request, this.user);
  }

  public static countCoordsDiffs(request: UserRequest, user: Contact, checkForNull: boolean = true): number {
    if (request.coords) {
      if (checkForNull) {
        return Number(request.coords.firstname != null && request.coords.firstname !== user.firstname) +
          Number(request.coords.lastname != null && request.coords.lastname !== user.lastname) +
          Number(request.coords.email != null && request.coords.email !== user.email) +
          Number(request.coords.phone != null && request.coords.phone !== user.phone);
      } else {
        return Number(request.coords.firstname != user.firstname) +
          Number(request.coords.lastname != user.lastname) +
          Number(request.coords.email != user.email) +
          Number(request.coords.phone != user.phone);
      }
    }
    return 0;
  }

  countCoordsDiffs(): number {
    return UserRequestComparatorComponent.countCoordsDiffs(this.request, this.user);
  }

  public static isRequestDifferentFromUser(request: UserRequest, user: Contact, checkForNull: boolean = true): boolean {
    const countProductsDiff = UserRequestComparatorComponent.countProductsDiffs(request);
    const isProfileDifferent = UserRequestComparatorComponent.isProfileDifferent(request, user);
    const countCoordsDiffs = UserRequestComparatorComponent.countCoordsDiffs(request, user, checkForNull);

    return countProductsDiff !== 0 || isProfileDifferent || countCoordsDiffs !== 0;
  }
}
